import { createPortal } from "react-dom";
import { Camera, Mic } from "lucide-react";

export const MediaPermPrompt = ({ state, onClose }) => {
  if (!state) return null;
  return createPortal(
    <div data-testid="media-perm-prompt" className={`fixed top-16 inset-x-3 z-[95] mx-auto max-w-sm rounded-2xl px-4 py-3 shadow-2xl border-2 fade-up ${state === "denied" ? "bg-red-950/95 border-red-500 text-red-50" : "bg-[#0D0306]/95 border-[var(--accent-c)] text-white"}`}>
      {state === "denied" ? (
        <div className="flex items-start gap-3">
          <span className="shrink-0 mt-0.5"><Mic size={16} /></span>
          <div className="flex-1">
            <p data-testid="media-perm-denied" className="text-xs font-bold leading-snug">കാമറ/മൈക്ക് അനുമതി ലഭിച്ചില്ല — അഡ്രസ് ബാറിലെ ലോക്ക് 🔒 ഐക്കൺ ടാപ്പ് ചെയ്ത് Camera / Microphone &quot;Allow&quot; ആക്കി വീണ്ടും കോൾ ചെയ്യുക.</p>
            <button type="button" data-testid="media-perm-dismiss" onClick={onClose} className="mt-2 text-[11px] font-bold underline">മനസ്സിലായി</button>
          </div>
        </div>
      ) : (
        <div className="flex items-center gap-3">
          <span className="flex items-center gap-1.5 shrink-0"><Camera size={16} /><Mic size={16} /></span>
          <p data-testid="media-perm-asking" className="text-xs font-bold leading-snug animate-pulse">കാമറ/മൈക്രോഫോൺ അനുമതി നൽകുക — ബ്രൗസർ ചോദിക്കുമ്പോൾ &quot;Allow&quot; / &quot;അനുവദിക്കുക&quot; ടാപ്പ് ചെയ്യുക</p>
        </div>
      )}
    </div>,
    document.body
  );
};
